// extracted by mini-css-extract-plugin
export default {"BannerTable":"BannerTable_BannerTable__ZQ01R","EditBanner":"BannerTable_EditBanner__qmnsT","DeleteButton":"BannerTable_DeleteButton__NwnQN"};